import { CardAction, CardActionLink, CardActionText } from './CardAction';
import { CardAlert } from './CardAlert';
import { CardClerkAndPagesTag } from './CardClerkAndPagesTag';
import { CardContent } from './CardContent';
import { CardFooter, CardFooterLinks } from './CardFooter';
import { CardRoot } from './CardRoot';

export const Card = {
  Root: CardRoot,
  Content: CardContent,
  Footer: CardFooter,
  Alert: CardAlert,
  Action: CardAction,
  ActionLink: CardActionLink,
  ActionText: CardActionText,
  FooterLinks: CardFooterLinks,
  ClerkAndPagesTag: CardClerkAndPagesTag,
};
